import { FormValidations } from "features/shared/forms/hooks/useForm";
import PhoneNumberValidatonRule from "features/validation/rules/PhoneNumberValidatonRule";

export const mobilePhoneFormValidations = (
  phonePrefixRef: React.RefObject<HTMLSelectElement>
): FormValidations => {
  return {
    DESC_TMMOBIL: {
      required: true,
      type: "PhoneNumber",
      prefix: phonePrefixRef.current ? phonePrefixRef.current.value : "+420",
      message: "invalidMobile",
    } as PhoneNumberValidatonRule
  };
};
